/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import {uuidv4} from "@/utils/helpers";
import {Type} from "class-transformer";
import {CompletedBy} from "@shared/Program/CompletedBy";
import dayjs from "dayjs";
import ParticipantItem from "@shared/scheduler/ParticipantItem";
import BaseAccessObject from "@shared/BaseAccessObject";
import {StepType, StepVisibility} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";


export default class ProgramStep extends BaseAccessObject{

	hasMoreRecurringEvents: boolean = null

	copiedFromId: string = ""
	name: string = ""
	subName: string = ""
	description: string = ""
	privateNote: string = ""
	publicNote: string = ""
	isFileReviewRequired: boolean = false
	goal: string = ""
	dueDateTs : number = 0;
	dateCompletedTs : number = 0;
	timeBasedItemId: string = null
	showAdvanced: string[] = []


	stepType: string = StepType.TASK
	stepVisibility: string = StepVisibility.PUBLIC

	@Type(() => ParticipantItem)
	participants: ParticipantItem[] = [];

	@Type(() => CompletedBy)
	completedByArray: CompletedBy[] = []

	expandedForOwnerIds: string[] = []


	// TODO Task also can have subtypes for contingency plan and they are not deserialized using types that leads to problems during recursive search
	// need to handle it

	//it's redefined in SectionProgramStep to handle sybtypes granularly using discriminator options.
	//it's not possible to handle it here directly because it produces circular dependencies
	@Type(() => ProgramStep)
	subStepList: ProgramStep[] = []


	constructor(name: string = "", description: string = "", subStepList: ProgramStep[] = [], stepType: ?string) {
		super();
		this.id = uuidv4();
		this.name = name;
		this.subStepList = subStepList;
		this.description = description;
		if (stepType) {
			this.stepType = stepType;
		}
	}

	resetId(){
		this.id = uuidv4();
	}

	reset(){
		this.participants = [];
		this.completedByArray = []
		this.copiedFromId = this.id
		this.resetId()
	}



	beforeSaveToDbOld(json: any): any {
		json = super.beforeSaveToDbOld(json)
		// json.completedByArray = firestore.arrayUnion(json.completedByArray);
		// we don't include the subStepList array here since
		// it can only be changed by a single person (the coach)
		// hence there is no concurrency here
		// besides it's recursive, which is not supported by firestore arrayUnion
		console.log("ProgramStep beforeSaveToDb: json = ", json)
		return json;
	}

	hasPaymentLocker(){
		return false
	}
	isLockedByPayment(){
		return false
	}

	isLocked() {
		return false
	}

	participantConfirmationCSSClass(email):string{
		let participant = this.findParticipantByEmail(email)
		return "text-dark"//participant ? participant.confirmationCssClass() : "text-dark"
	}
	participantConfirmationPending(email): boolean{
		let participant = this.findParticipantByEmail(email)
		return (participant && participant.isPending());
	}
	participantConfirmationConfirmed(email): boolean{
		let participant = this.findParticipantByEmail(email)
		return (participant && participant.isConfirmed());
	}
	participantConfirmationDeclined(email): boolean{
		let participant = this.findParticipantByEmail(email)
		return (participant && participant.isCancelled());
	}


	findSubStepsByType(stepType){
		let res = []
		this.subStepList.forEach(step => {
			if(step.stepType === stepType){
				res.push(step)
			}
		})
		return res
	}
	isTypeCall(){
		return this.stepType === StepType.CALL;
	}
	isTypeTask(){
		return this.stepType === StepType.TASK;
	}
	isTypeNote(){
		return this.stepType === StepType.NOTE;
	}
	isTypeContract(){
		return this.stepType === StepType.CONTRACT;
	}
	isTypeSection(){
		return this.stepType === StepType.SECTION;
	}
	isPublic(){
		return this.stepVisibility === StepVisibility.PUBLIC
	}
	canShowTo(userId){
		let canShow = this.isPublic() || this.isOwner(userId)
		return canShow
	}
	canEditBy(userId){
		return this.isOwner(userId)
	}


	findParticipantByEmail(email: string){
		return this.participants.find(item => item.email === email)
	}

	dueDateFormatted(){
		return dayjs(this.dueDateTs).format("MMM DD")
	}
	isDueFor(userId){
		return this.dueDateTs > 0 && new Date().getTime() > this.dueDateTs && !this.isCompleted(userId)
	}



	equalableProps() {
		return [
			"goal",
			"location",
			"durationMinutes",
			"timeOptions",
			"confirmedTime",
			"isRecurring",
			"recurrence",
			"emailReminder",
			"confirmationStatus"
		]
	}



}



